/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![WebhookPlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACDElEQVR4nM2Vv2sUURDHg9gJYuMvLGwsbAQLWzlBg+dlZ76zkc3MXgL2ohDBWClXiIWtfTqL1GIhikoMFv4Htho1ahELUfHEKPPu7XHKHbfeS+GDaXb2fT+z3/dmdmrqf1iZ6DmC3mfoNw8SWwVK2hZxgt5ksS0W+/VXbBH0RlrlKCWK/cigV4lsf54v7GPRJYJ2PQfoqcmrF1t1ERdnNmaxNwRdd8vCM4dDH08MYLEvLuKVM2xjwJ5XraI4EHKwzwkAfe8iwZYBAEHfhTx0jcSeTQwg0QexymskCheOgJ9J3lcrg56OgO8OaTQaO1msEyHrwIU9yRAWu1VZk6G86BCCvoiQ5WTAzExxKDSY9wLbifBls+VRgn2N0PNJAIIuh2rFVv58bovxKz40i2LvROJeqTeZNxVRcWQw1+l0dpDYEz8foH28liAwd9ZvDsHuhipF7/X81zvD3vfrC7SP1RL3udK/52IvAT1ZNZI32tj9Ys+9L4YmmefOVNeR2a5MTy/sChskAK/XKbAqbngS+jACFn3mkOjb3pyxDYdtA8A+etJvQ198SBC025ptH/53gOhmHQCLbjab87t9z4CFo6M6ExJ7Wo1lEs18DJDYa6BsjbQEujYO0B+Ecdb3Dll0Kc/nD3pE4CcSvZR0BtGm26O9t8vJAF9hJIfu1G78uT+i3JrjxGsDUtaon89vM3p3r8TIUrMAAAAASUVORK5CYII=)
 */
export const WebhookPlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19 14a1 1 0 0 1 1 1v3h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1ZM5.97 13.88a1 1 0 0 1-.72 1.21 3 3 0 1 0 2.73 5.16 1 1 0 1 1 1.33 1.5A4.98 4.98 0 0 1 1 18a5 5 0 0 1 3.75-4.84 1 1 0 0 1 1.22.72Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M11.65 17c.43 0 .69.55.54.95-.07.18-.12.36-.15.55-.04.27-.26.5-.54.5H7.73a2 2 0 1 1-1.78-3l3.2-5.9A5 5 0 1 1 17 6a1 1 0 1 1-2 0 3 3 0 1 0-4.12 2.78 1 1 0 0 1 .5 1.4L7.7 16.96l.02.05h3.92Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M17.12 12.66c.23-.18.32-.52.15-.76L13.8 6.86A2 2 0 1 0 12.16 8l3.52 5.13c.23.33.75.28 1-.03.14-.16.28-.3.44-.43Z"
        className={colorClass}
      />
    </svg>
  );
};
